$(document).on("change", ".toggle-expense-index", function () {
  var checkbox        = $(this);
  var expenseIndexId  = checkbox.data("id");
  var checkUrl        = checkbox.data("check-url");
  var enabled         = checkbox.is(":checked");

  if (!enabled) {
    $.getJSON(checkUrl, function (response) {
      if (!response.deletable) {
        var confirmed = window.confirm("この経費科目を非表示にしますか？過去に登録済みのデータは保持されます。");
        if (!confirmed) {
          checkbox.prop("checked", true);
          return;
        }else{
          doToggle(checkbox, expenseIndexId, enabled);
        }
      } else {
        doToggle(checkbox, expenseIndexId, enabled);
      }
    }).fail(function () {
      checkbox.prop("checked", true);
      alert("確認中にエラーが発生しました。");
    });
  } else {
    doToggle(checkbox, expenseIndexId, enabled);
  }
});

function doToggle(checkbox, expenseIndexId, enabled) {
  $.ajax({
    url: "/expense_indexes/" + expenseIndexId + "/toggle_enabled",
    type: "PATCH",
    data: { enabled: enabled },
    headers: { "X-CSRF-Token": $("meta[name='csrf-token']").attr("content") },
    success: function () {
      alert(enabled ? "有効にしました。" : "無効にしました。");
    },
    error: function () {
      alert("アップデートエラー");
      checkbox.prop("checked", !enabled);
    }
  });
}
